import { api } from "./index";

export function getClaim(claimNumber) {
  return api.get(`/webapp/claims/${claimNumber}`);
}
